<template>
  <div class="register absolute">
   <!-- <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img src="@assets/images/logo2.png" />
      </div>
    </div> -->
    <div class="whiteBg">
      <div class="title">注册账号</div>
      <div class="list"> 
        <div class="item acea-row row-middle">
		  <div class="title1">手机号</div>
          <div>
            <input type="text" placeholder="输入手机号码" v-model="account"/> 
          </div>
        </div>
		<div class="item acea-row row-middle">
		  <div class="title1">体系</div>
		  <div>
		    <input type="text" placeholder="输入所属体系"  v-model="tixi"/>
		  </div>
		</div>
		<div class="item acea-row row-middle">
		  <div class="title1">姓名</div>
		  <div>
		    <input type="text" placeholder="输入会员姓名" v-model="real_name"/>
		  </div>
		</div>
		<div class="item acea-row-nowap row-middle">
		  <div class="title1">推荐人</div>
		  <div class="acea-row-nowap row-middle">
		    <input type="text" placeholder="输入推荐人会员号" v-model="zhitui_nickname" @change="zhituiChange"/>
			<div class="tips">{{tuijian.real_name}}</div>
		  </div>
		</div>
		<div class="item acea-row row-middle">
		  <div class="title1">安置人</div>
		  <div class="acea-row-nowap row-middle">
		    <input type="text" placeholder="输入安置人会员号" v-model="spread_nickname" @change="spreadChange"/>
			<div class="tips">{{anzhi.real_name}}</div>
		  </div>
		</div>
		<div class="item acea-row row-middle">
		  <div class="title1">安置位置</div>
		  <div>
		     <select v-model="area">
				 <option value="1">左区</option>
				 <option value="2">右区</option>  
			 </select>
		  </div>
		</div>
    <!--    <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input type="text" placeholder="填写验证码" class="codeIput" />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div> -->
        <div class="item acea-row row-middle">
		  <div class="title1">密码</div>
          <div> 
            <input type="text" placeholder="填写您的登录密码" v-model="password"/>
          </div>
        </div>
		<div class="item acea-row row-middle">
		  <div class="title1">重复密码</div>
		  <div> 
		    <input type="text" placeholder="请再输入一遍密码" v-model="repassword"/>
		  </div>
		</div>
      </div>
      <div class="logon"  @click="register">注册</div>
    <!--  <div class="tip">
        已有账号?
        <span @click="$router.push({ name: 'Login' })" class="font-color-red"
          >立即登录</span
        >
      </div> -->
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script>
import sendVerifyCode from "@mixins/SendVerifyCode";

import { getUser, getMenuUser,getUserByNo,getUserInfo,register } from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
export default {
  name: "Register",
  mixins: [sendVerifyCode],
  data: function() {
    return {
      userInfo: {},
      tuijian: {},
	  anzhi: {},
      orderStatusNum: {},
	  account: "",
	  password: "",
	  repassword:"",
	  tixi:"",
	  real_name:"",
	  area:"",
	  partner_id:"", //报单中心
	  spread_uid:"", //安置人
	  spread_nickname:"", //安置人
	  zhitui_uid:"", //直推人
	  zhitui_nickname:"", 
      switchActive: false,
      isWeixin: false
    };
  },
  watch: {
    $route(n) {
      if (n.name === name) this.User();
    },
	$route(to, form) {
		let that=this;
		that.area=this.$route.params.type;
		if(this.$route.params.id && this.$route.params.id != 0){  //id 参数是0时居然能通过，解释是if会优先判断 this.$route.params.id是否定义，如果定义就会返回真
			this.getAnZhiRen(this.$route.params.id);
		}
	}
  },
  mounted: function() {
	this.User();
	//console.log(this.$route.params.id); //this.$route.params.id 十个字符串0 不是数字0  不能使用 this.$route.params.id !== 0
    let that=this;
	that.area=this.$route.params.type;
	if(this.$route.params.id && this.$route.params.id != 0){  //id 参数是0时居然能通过，解释是if会优先判断 this.$route.params.id是否定义，如果定义就会返回真
		this.getAnZhiRen(this.$route.params.id);
	}
  },
  methods: {
    code: function() {
      this.sendCode();
    },
	User: function() {
	  let that = this;
	  getUserInfo().then(res => {
	    that.userInfo = res.data; 
		that.partner_id=res.data.uid;
	  });
	},
	getTuiJianRen: function(id) {
	  let that = this;
	  getUserByNo(id).then(res => { 
		  console.log(typeof res.data);
		  if(typeof res.data === 'object' && res.data !== null && !Array.isArray(res.data)){ 
			that.tuijian = res.data;
			that.zhitui_uid=res.data.uid;
			that.zhitui_nickname=res.data.nickname;
		  }else{
			  that.tuijian={};
			  that.zhitui_uid="";
			  that.tuijian.real_name="不存在";
			  this.$dialog.message('不存在用户，请检查！');
		  }
	  });
	},
	getAnZhiRen: function(id) {
	  let that = this;
	  getUserByNo(id).then(res => {
	    if(typeof res.data === 'object' && res.data !== null && !Array.isArray(res.data)){
			that.anzhi = res.data;
			that.spread_uid=res.data.uid;
			that.spread_nickname=res.data.nickname;
		}else{
			that.anzhi={};
			that.spread_uid="";
			that.anzhi.real_name="不存在";
			this.$dialog.message('不存在用户，请检查！');
		} 
	  });
	},
	spreadChange:function(){
		let $id=this.spread_nickname;
		this.getAnZhiRen($id); 
	},
	zhituiChange:function(){
		let $id=this.zhitui_nickname;
		this.getTuiJianRen($id);
	},
	async register() {
	  var that = this;
	  const { account, real_name,zhitui_nickname,spread_nickname, password } = that;
	  try {
	    await that
	      .$validator({
	        account: [
	          required(required.message("手机号码")),
	          chs_phone(chs_phone.message())
	        ],
	        real_name: [
	          required(required.message("姓名")), 
	        ], 
			zhitui_nickname: [
			  required(required.message("推荐人")), 
			],
			spread_nickname: [
			  required(required.message("安置人")), 
			],
	        password: [
	          required(required.message("密码")),
	          attrs.range([6, 16], attrs.range.message("密码")),
	          alpha_num(alpha_num.message("密码"))
	        ]
	      })
	      .validate({ account, real_name,zhitui_nickname,spread_nickname, password });
	  } catch (e) {
	    return validatorDefaultCatch(e);
	  }
	  if(that.password!=that.repassword){
		   this.$dialog.message('两次输入密码不同');
		   return;
	  }
	  if(that.partner_id==""){
		   this.$dialog.message('请输入报单中心');
		   return;
	  }
	  if(that.zhitui_uid==""){
	  		   this.$dialog.message('未找到正确的推荐人');
	  		   return;
	  }
	  if(that.spread_uid==""){
		   this.$dialog.message('未找到正确的安置人');
		   return;
	  }
	  
	  register({
	    account: that.account,
	    tixi: that.tixi,
		real_name: that.real_name, 
	    spread_uid: that.spread_uid,
		zhitui_uid:that.zhitui_uid,
		area:that.area,
		password: that.password,
		partner_id:that.partner_id
	  })
	    .then(res => {
	      that.$dialog.success(res.msg);
		  that.account="";
		  that.tixi="";
		  that.real_name="";
		  that.spread_uid="";
		  that.zhitui_uid="";
		  that.password="";
		  that.repassword="";
		  that.zhitui_nickname="";
		  that.spread_nickname="";
		  that.tuijian="";
		  that.anzhi="";
	      this.$router.go(-1);
	    })
	    .catch(res => {
	      that.$dialog.error(res.msg);
	    });
	}
  }
};
</script>

<style scoped>
 .register{background: none}
 .register .whiteBg{width: 100%; margin-top: 0; height: 100%;}
 .register .bottom{background: none}
 .title1{font-size: 0.33rem; width: 1.8rem;}
 
</style>